import type { UnderSaturatedCondensateViscosityParameters } from "../../d";

export function underSaturatedCondensateViscosityCalculator(
  params: UnderSaturatedCondensateViscosityParameters
): {
  m: number;
  undersaturatedCondensateViscosity: number;
} {
  const {
    inSituPressurePSIA,
    bubblePointPressurePSIA,
    saturatedCondensateViscosity
  } = params;

  // Q40: =2.6*(D3**1.187)*EXP(-11.513-8.98*(10**-5)*D3)
  const m =
    2.6 *
    inSituPressurePSIA ** 1.187 *
    Math.exp(-11.513 - 8.98 * 10 ** -5 * inSituPressurePSIA);

  // Q42: =Q20*(D3/J18)**Q40
  const undersaturatedCondensateViscosity =
    saturatedCondensateViscosity *
    (inSituPressurePSIA / bubblePointPressurePSIA) ** m;

  return {
    m,
    undersaturatedCondensateViscosity
  };
}
